// Intent: [Conversion] [Lead Gen] [Branding]
import React from "react";
import { ButtonLink } from "../shared/ButtonLink";
function FinalCTA() {
  return <section id="final-cta" className="bg-pfpc-navy py-9 text-pfpc-offwhite md:py-11" data-id="element-122" data-mp="5cqy0f7hu19q">
      <div className="container-shell flex flex-col gap-5 text-center lg:flex-row lg:items-center lg:justify-between lg:text-left" data-id="element-123" data-mp="3msz0zwqiyxvv">
        <div data-id="element-124" data-mp="3rqs5mlc6jju1">
          <h2 className="font-heading text-[26px] font-extrabold leading-[1.15] md:text-[32px]" data-id="element-125" data-mp="3dt3kdce7aaog">Ready to design your cabinets online?</h2>
          <p className="mt-2 text-[15px] leading-6 text-pfpc-offwhite/70" data-id="element-126" data-mp="3hvqh9rpqalsi">Choose the pathway that matches your project.</p>
        </div>
        <div className="flex flex-col justify-center gap-3 sm:flex-row lg:justify-end" data-id="element-127" data-mp="33wqw4u1fcp13">
          <ButtonLink href="/register/trade/" analytics="trade_register_clicked" variant="secondaryDark" data-id="element-128" data-mp="38uit42gxf1c5">Trades</ButtonLink>
          <ButtonLink href="/register/diy/" analytics="diy_register_clicked" data-id="element-129" data-mp="121q7fxjtd93i">Do It Yourself - Easy</ButtonLink>
        </div>
      </div>
    </section>;
}
export { FinalCTA };